import getUrl from './getUrl.js';

export default function singleListing(idListing, quantity) {
    return fetch(`${getUrl()}/v2/order/${idListing}?qty=${quantity}`, {
        method: 'POST',
        headers: {
          'Content-type':'application/json'
        },
        credentials: 'include',
      })
      .then((res) => res.json())
}